//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// LIVE LESSONS

var liveLessonsData = null;
var liveLessonTarget = $('[data-live-lessons]');
// var countdownInterval;

$(function () {
	if (liveLessonTarget.length) {
		fetchLiveLessonsData();
	}
});

window.fetchLiveLessonsData = async function fetchLiveLessonsData() {

	var requestURL = siteUrl + '/live-lessons/' + teacherUID + '.json';
	
	console.log(requestURL)

	try {
		const response = await $.ajax({
			type: 'get',
			url: requestURL,
		});
		
		liveLessonsData = response.data;

		console.log(liveLessonsData)

		// Clear existing content
		liveLessonTarget.empty();

		if (liveLessonsData.length) {
			// Iterate through the data and append each result as a separate row
			liveLessonsData.forEach(function(lesson) {

				var expiryTimestamp = lesson.expiry;
				var now = Math.floor(new Date().getTime() / 1000);
				var remainingTime = expiryTimestamp - now;
				
				var formattedTime = window.getFormattedTime(remainingTime);

				if (lesson.extended) {
					var extendBtn = `<button class="btn btn-black btn-transparent btn-smaller extended">Extended</button>`;
				} else {
					var extendBtn = `<button data-extend-timer data-lesson-uid="` + lesson.uid + `" data-post-action="refresh-live-lessons" class="btn btn-black btn-transparent btn-smaller">Extend time</button>`;
				}

				// console.log('lesson.activitiesEnabled ' + lesson.activitiesEnabled)
				if (lesson.activitiesEnabled) {
					var activitiesBtn = `
						<div data-activities-status="` + lesson.activitiesStatus + `" data-lesson-uid="` + lesson.uid + `">
							<div class="heading">Enable activities</div>	
							<div class="toggle"><div></div></div>
						</div>
					`;
				} else {
					var activitiesBtn = ``;
				}

				var students = lesson.students > 0 ? '<div class="sessions"><div>' + lesson.students + (lesson.students > 1 ? ' <span class="desktop-label">&nbsp;sessions</span>' : ' <span class="desktop-label">&nbsp;session</span>') + '</div></div>': '';

				var results = '';
				results = `
					<a class="results-link" href="/account/results/` + lesson.uid + `">
						<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
						<g transform="translate(-1227 -16)">
						<g transform="translate(1227 16)" fill="none" stroke="#000" stroke-width="1.5" opacity="0.2">
						<circle cx="19" cy="19" r="19" stroke="none"/>
						<circle cx="19" cy="19" r="18.25" fill="none"/>
						</g>
						<path d="M12.5,10.833a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,12.5,10.833Zm7.5-.374s-3.543,6.208-9.988,6.208C4.029,16.667,0,10.459,0,10.459S3.7,5,10.012,5C16.424,5,20,10.459,20,10.459Zm-5.833.374A4.167,4.167,0,1,0,10,15,4.167,4.167,0,0,0,14.167,10.833Z" transform="translate(1236 24.5)"/>
						</g>
						</svg>
					</a>
				`;

				var colCode = '';
				var colResults = '';
				var liveLessonBtn = '';
				if (lesson.lessonType == 'lesson') {
					colCode = `
						<a href="/code/` + lesson.uid + `" target="_blank" data-code>
							<span class="mobile-label">Join code:&nbsp;&nbsp;</span>
							<span>` + lesson.code + `</span>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
								<path d="M22,5a1,1,0,0,0-1-1H3A1,1,0,0,0,2,5V19a1,1,0,0,0,1,1H21a1,1,0,0,0,1-1ZM14.435,8.522H13.217a.75.75,0,1,1,0-1.5H16.25a.75.75,0,0,1,.75.75v3.05a.75.75,0,0,1-1.5,0V9.578L9.582,15.5H10.8a.75.75,0,1,1,0,1.5H7.768a.75.75,0,0,1-.75-.75V13.2a.75.75,0,0,1,1.5,0v1.243Z" transform="translate(-2 -4)"/>
							</svg>
						</a>
					`;
					colResults = `
						<div class="col col-students-live" data-students="` + lesson.students + `">
							<span class="mobile-label">Activity:&nbsp;&nbsp;&nbsp;</span>
							` + students + results + `
						</div>
					`;

					liveLessonBtn = 'Go to live lesson';

				}
				if (lesson.lessonType == 'mini') {
					colResults = `
						<div class="col col-students-live"></div>
					`;

					liveLessonBtn = 'Go to live mini';
				}

				var row = `
					<div class="lesson-row">
						<div class="col col-title-live" data-title>
							<a href="/` + lesson.uri + `" target="_blank">
								<span>` + lesson.title + `</span>
								<span class="btn btn-grey btn-transparent btn-smaller">` + liveLessonBtn + `</span>
							</a>
						</div>
						` + colResults + `
						<div class="col col-code">
							` + colCode + `
						</div>
						<div class="col col-timer" data-time="` + lesson.expiry + `">
							<span class="mobile-label">Expires in:&nbsp;&nbsp;</span>
							<div class="" data-lesson-expiry="` + lesson.expiry + `" data-lesson-uid="` + lesson.uid + `">
								<span class="timer">` + formattedTime + `</span>
							</div>
							` + extendBtn + `
						</div>
						<div class="col col-activities">
							` + activitiesBtn + `
						</div>
						<div class="col col-1 col-finish">
							<button data-finish-lesson data-post-action="refresh-recent-lessons" data-lesson-uid="` + lesson.uid + `" class="btn btn-yellow btn-fill btn-smaller">Finish</button>
							` + extendBtn + `
						</div>
					</div>
				`;
				liveLessonTarget.append(row);
			});

			window.countdownInterval = setInterval(updateCountdown, 60000);

		} else {
			var row = `
				<div class="lesson-row">
					<div class="col col-9">Nothing found.</div>
				</div>
			`;
			liveLessonTarget.append(row);
		}


	} catch (error) {
		console.log('Error fetching JSON data');
		console.log(error);
	}

}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// RECENT LESSONS

var recentLessonsData = null;
var recentLessonTarget = $('[data-recent-lessons]');
var paginationDiv = $('[data-recent-lessons-pagination]');

$(function () {
	if (recentLessonTarget.length) {
		var version = recentLessonTarget.attr('data-recent-lessons');
		fetchRecentLessonsData(version);
	}
});

window.fetchRecentLessonsData = async function fetchRecentLessonsData(version, page) {

	var query = '';
	if (version == 'mini') {
		query = '?limit=5';
	} else if (page) {
        query = '?page=' + page;
    }

	var requestURL = siteUrl + '/recent-lessons/' + teacherUID + '.json' + query;
	
	console.log('Fetching JSON data...');
	console.log(requestURL)
	try {
		const response = await $.ajax({
			type: 'get',
			url: requestURL,
		});
		
		recentLessonsData = response.data;
        pageData = response.meta.pagination;

		console.log(recentLessonsData)

		// Clear existing content
		recentLessonTarget.empty();

		if (recentLessonsData.length) {
			// Iterate through the data and append each result as a separate row
			recentLessonsData.forEach(function(lesson) {

				var expiryTimestamp = lesson.expiry;
				
				var date = new Date(expiryTimestamp * 1000); // Convert seconds to milliseconds
				var hours = date.getHours();
				var ampm = hours >= 12 ? 'pm' : 'am';
				hours = hours % 12;
				hours = hours ? hours : 12; // Handle midnight
				var minutes = ('0' + date.getMinutes()).slice(-2);
				var day = ('0' + date.getDate()).slice(-2);
				var month = ('0' + (date.getMonth() + 1)).slice(-2);
				var year = date.getFullYear().toString();
				
				var formattedExpiry = hours + ':' + minutes + ampm + ' ' + day + '.' + month + '.' + year;
				
				var results = '';
				if (lesson.students > 0) {
					results = `
						<a class="results-link" href="/account/results/` + lesson.uid + `">
							<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
							<g transform="translate(-1227 -16)">
							<g transform="translate(1227 16)" fill="none" stroke="#000" stroke-width="1.5" opacity="0.2">
							<circle cx="19" cy="19" r="19" stroke="none"/>
							<circle cx="19" cy="19" r="18.25" fill="none"/>
							</g>
							<path d="M12.5,10.833a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,12.5,10.833Zm7.5-.374s-3.543,6.208-9.988,6.208C4.029,16.667,0,10.459,0,10.459S3.7,5,10.012,5C16.424,5,20,10.459,20,10.459Zm-5.833.374A4.167,4.167,0,1,0,10,15,4.167,4.167,0,0,0,14.167,10.833Z" transform="translate(1236 24.5)"/>
							</g>
							</svg>
						</a>
						<div data-download-results data-lesson-uid="` + lesson.uid + `">
							<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
							<g transform="translate(-1273 -16)">
							<g transform="translate(1273 16)" fill="none" stroke="#000" stroke-width="1.5" opacity="0.2">
							<circle cx="19" cy="19" r="19" stroke="none"/>
							<circle cx="19" cy="19" r="18.25" fill="none"/>
							</g>
							<path d="M8.5,14.318,3.045,8.182H7.136V0H9.864V8.182h4.091Zm6.136-.682V15H2.364V13.636H1v2.727H16V13.636Z" transform="translate(1284 26.5)"/>
							</g>
							</svg>
						</div>
					`;
				}

				var colTitle = '';
				var createBtn = '';
				if (lesson.lessonType == 'lesson') {
					colTitle = `
						<div class="col col-title" data-title>
							<a href="/lesson-overview/` + lesson.originalLessonUID + `" target="_blank">
								<span>` + lesson.title + `</span>
								<span class="btn btn-grey btn-transparent btn-smaller">Go to teacher overview</span>
							</a>
						</div>
					`;
					createBtn = `<button data-create-live-code data-post-action="refresh-live-lessons" data-lesson-uid="` + lesson.originalLessonUID + `" class="btn btn-yellow btn-fill btn-smaller">Create join code</button>`;
				}
				if (lesson.lessonType == 'mini') {
					colTitle = `
						<div class="col col-title" data-title>
							<a data-lesson-popup-trigger data-uid="` + lesson.originalLessonUID + `" href="javascript:;">
								<span>` + lesson.title + `</span>
								<span class="btn btn-grey btn-transparent btn-smaller">Read description</span>
							</a>
						</div>
					`;
					createBtn = `<button data-create-live-code data-post-action="refresh-live-lessons" data-lesson-uid="` + lesson.originalLessonUID + `" class="btn btn-yellow btn-fill btn-smaller">Run this mini</button>`;
				}


				var row = `<div class="lesson-row">
						` + colTitle + `
						<div class="col col-date" data-time="` + lesson.expiry + `">
							<span class="mobile-label">Finished:&nbsp;&nbsp;</span>
							` + formattedExpiry + `
						</div>
						<div class="col col-interactions" data-students="` + lesson.students + `">
							<span class="mobile-label">Interactions:&nbsp;&nbsp;</span>
							` + lesson.students + `
						</div>
						<div class="col col-results">
							<span class="mobile-label">Results:&nbsp;&nbsp;</span>
							` + results + `
						</div>
						<div class="col col-action">
							` + createBtn + `
							<button data-remove-lesson data-post-action="refresh-recent-lessons-` + version + `" data-lesson-uid="` + lesson.uid + `">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="19.2" viewBox="0 0 16 19.2"><g transform="translate(0 0)"><path id="iconmonstr-trash-can-28" d="M15.6,19.2H4.4a1.6,1.6,0,0,1-1.6-1.6V4H2V2.4H6.8V1.2A1.2,1.2,0,0,1,8,0h4a1.2,1.2,0,0,1,1.2,1.2V2.4H18V4h-.8V17.6A1.6,1.6,0,0,1,15.6,19.2ZM15.6,4H4.4V17.2a.4.4,0,0,0,.4.4H15.2a.4.4,0,0,0,.4-.4ZM8.4,7.2a.8.8,0,0,0-1.6,0v7.2a.8.8,0,0,0,1.6,0Zm4.8,0a.8.8,0,1,0-1.6,0v7.2a.8.8,0,0,0,1.6,0ZM11.6,1.6H8.4v.8h3.2Z" transform="translate(-2 0)" fill="currentColor" fill-rule="evenodd"/></g></svg>
							</button>
						</div>
					</div>
				`;
				recentLessonTarget.append(row);
			});

            pagination(pageData);

		} else {
			var row = `
				<div class="lesson-row">
					<div class="col col-9">Nothing found.</div>
				</div>
			`;
			recentLessonTarget.append(row);
		}

        if (page) {
            $('html, body').animate({
                scrollTop: $('.recent-lessons-section').offset().top
            }, 500);
        }


	} catch (error) {
		console.log('Error fetching JSON data');
		console.log(error);
	}
}

$(document).on('click','[data-recent-lessons-pagination] .page:not(.active)', function() {

    $('[data-recent-lessons-pagination] .page').removeClass('active');
    $(this).addClass('active');

    var page = $(this).attr('data-page');
    fetchRecentLessonsData('full', page)

});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PAGINATION

function pagination(pageData) {
    console.log(pageData)
    var totalPages = pageData.total_pages;
    var currentPage = pageData.current_page;

    var pagesHtml = ``;
    for (var i = 1; i <= totalPages; i++) {
        pagesHtml = pagesHtml + '<div class="page ' + (currentPage == i ? 'active' : '') + '" data-page="' + i + '">' + i + '</div>';
    }

    paginationDiv.html(pagesHtml);

}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// COUNTDOWN

window.updateCountdown = function updateCountdown() {
    $('[data-lesson-expiry]').each(function() {
        var expiryTimestamp = parseInt($(this).data('lesson-expiry'));
        var now = Math.floor(new Date().getTime() / 1000); // Current time in seconds
        var remainingTime = expiryTimestamp - now;

		var formattedTime = window.getFormattedTime(remainingTime);

        // Update the timer display
        $(this).find('.timer').text(formattedTime);

		if (remainingTime <= 3600) {
            $(this).find('.timer').addClass('red');
        }

        // If the countdown is finished, clear the interval
        if (remainingTime <= 0) {
            clearInterval(countdownInterval);
			$(this).find('.timer').text('0:00:00');
			if (liveLessonTarget.length) {
				fetchLiveLessonsData();
			}
			if (recentLessonTarget.length) {
				fetchRecentLessonsData('mini');
			}
        }
    });
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TABLE SORTING

$(document).ready(function() {

    var sortDirection = 'asc';
	var titleSortEl = $('[data-sort-title]');
	var studentsSortEl = $('[data-sort-students]');
	var timeSortEl = $('[data-sort-time]');

    titleSortEl.on('click', function() {
        sortDirection = (sortDirection === 'asc') ? 'desc' : 'asc';
		$(this).attr('data-sort', sortDirection);
		var section = $(this).closest('section');
		section.find(studentsSortEl).attr('data-sort', 'none');
		section.find(timeSortEl).attr('data-sort', 'none');
        sortLessonsByTitle(sortDirection, section);
    });

    studentsSortEl.on('click', function() {
        sortDirection = (sortDirection === 'asc') ? 'desc' : 'asc';
		$(this).attr('data-sort', sortDirection);
		var section = $(this).closest('section');
		section.find(titleSortEl).attr('data-sort', 'none');
		section.find(timeSortEl).attr('data-sort', 'none');
        sortLessonsByStudents(sortDirection, section);
    });

    timeSortEl.on('click', function() {
        sortDirection = (sortDirection === 'asc') ? 'desc' : 'asc';
		$(this).attr('data-sort', sortDirection);
		var section = $(this).closest('section');
		section.find(titleSortEl).attr('data-sort', 'none');
		section.find(studentsSortEl).attr('data-sort', 'none');
        sortLessonsByTime(sortDirection, section);
    });

});

function sortLessonsByTitle(direction, section) {
    var lessonRows = section.find('.lesson-row:not(.lesson-row-heading)').toArray();
    lessonRows.sort(function(a, b) {
        var titleA = $(a).find('[data-title] a').text().toUpperCase();
        var titleB = $(b).find('[data-title] a').text().toUpperCase();
        if (direction === 'asc') {
            return (titleA < titleB) ? -1 : (titleA > titleB) ? 1 : 0;
        } else {
            return (titleA > titleB) ? -1 : (titleA < titleB) ? 1 : 0;
        }
    });
    section.find('.lesson-grid-lessons').empty();
    $.each(lessonRows, function(index, row) {
        section.find('.lesson-grid-lessons').append(row);
    });
}

function sortLessonsByStudents(direction, section) {
    var lessonRows = section.find('.lesson-row:not(.lesson-row-heading)').toArray();
    lessonRows.sort(function(a, b) {
        var studentsA = parseInt($(a).find('[data-students]').attr('data-students'));
        var studentsB = parseInt($(b).find('[data-students]').attr('data-students'));
        if (direction === 'asc') {
            return studentsA - studentsB;
        } else {
            return studentsB - studentsA;
        }
    });
    section.find('.lesson-grid-lessons').empty();
    $.each(lessonRows, function(index, row) {
        section.find('.lesson-grid-lessons').append(row);
    });
}

function sortLessonsByTime(direction, section) {
    var lessonRows = section.find('.lesson-row:not(.lesson-row-heading)').toArray();
    lessonRows.sort(function(a, b) {
        var studentsA = parseInt($(a).find('[data-time]').attr('data-time'));
        var studentsB = parseInt($(b).find('[data-time]').attr('data-time'));
        if (direction === 'asc') {
            return studentsA - studentsB;
        } else {
            return studentsB - studentsA;
        }
    });
    section.find('.lesson-grid-lessons').empty();
    $.each(lessonRows, function(index, row) {
        section.find('.lesson-grid-lessons').append(row);
    });
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USER MENU

$('.menu-user .btn').on("click", function(e) {
    e.stopPropagation();
    $('.menu-user .btn').toggleClass('open');
});
$(document).on("click", function(e) {
    $('.menu-user .btn').removeClass('open');
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HELP MENU

$('.help-menu [data-help-menu]').on("click", function(e) {
    e.stopPropagation();
    $('[data-help-menu]').toggleClass('open');
});
$(document).on("click", function(e) {
    $('[data-help-menu]').removeClass('open');
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SORT DROPDOWN

$('.sort-dropdown .btn').on("click", function(e) {
    e.stopPropagation();
    $('.sort-dropdown .btn').toggleClass('open');
    if ($('.sort-dropdown .btn').hasClass('open')) {
        // $('.menu-user .btn span').html('Close');
    } else {
        // $('.menu-user .btn span').html('Menu');
    }
});
$(document).on("click", function(e) {
    $('.sort-dropdown .btn').removeClass('open');
    // $('.menu-user .btn span').html('Menu');
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// RESULTS

var resultsHeaderData = null;
var resultsStudentData = null;
var resultsTarget = $('[data-results-grid]');
var countdownResultsTarget = $('[data-results-countdown]');

$(function () {
	if (resultsTarget.length) {
		fetchDataAndBuildTable();
	}
});

window.fetchResultsHeaderData = async function fetchResultsHeaderData() {

	var ID = resultsTarget.attr('data-lesson-id');
	var originalID = resultsTarget.attr('data-original-lesson-id');

	var requestURL = siteUrl + '/data-lesson-live/' + ID + '-' + originalID + '.json';
	
	console.log('Fetching fetchResultsHeaderData data...');
	console.log(requestURL)
	try {
		const response = await $.ajax({
			type: 'get',
			url: requestURL,
		});
		
		resultsHeaderData = response.data[0].quizzes;

		console.log(resultsHeaderData)

		return resultsHeaderData;

	} catch (error) {
		console.log('Error fetching JSON data');
		console.log(error);
	}
}

window.fetchResultsStudentData = async function fetchResultsStudentData() {
	const UID = resultsTarget.attr('data-lesson-uid');
	const requestURL = siteUrl + '/results/' + UID + '.json';
	const cacheKey = `resultsStudentData_${UID}`;
	const cacheExpirationKey = `${cacheKey}_expiration`;
	const cacheDuration = 3 * 60 * 1000;

	// Check if cached data is available and valid
	const cachedData = localStorage.getItem(cacheKey);
	const cacheExpiration = localStorage.getItem(cacheExpirationKey);
	if (cachedData && cacheExpiration && countdownResultsTarget.length) {
		const remainingTime = cacheExpiration - new Date().getTime();
		if (remainingTime > 0) {
			console.log('Using cached resultsStudentData...');
			startResultsCountdown(remainingTime);
			return JSON.parse(cachedData);
		}
	}

	console.log('Fetching fresh resultsStudentData data...');
	console.log(requestURL);
	try {
		const response = await $.ajax({
			type: 'get',
			url: requestURL,
		});
		
		resultsStudentData = response.data[0].students;

		// console.log(resultsStudentData);

		if (countdownResultsTarget.length) {
			// Cache the data with an expiration timestamp
			localStorage.setItem(cacheKey, JSON.stringify(resultsStudentData));
			const expirationTime = new Date().getTime() + cacheDuration;
			localStorage.setItem(cacheExpirationKey, expirationTime);

			// Start countdown for the next refresh
			startResultsCountdown(cacheDuration);
		}

		return resultsStudentData;
	} catch (error) {
		console.log('Error fetching JSON data');
		console.log(error);
	}
}

// Function to start the countdown timer
function startResultsCountdown(duration) {
	
	let remainingTime = duration;

	const countdownInterval = setInterval(() => {
		if (remainingTime <= 0) {
			clearInterval(countdownInterval);
			countdownResultsTarget.text('Refreshing table...');
			fetchDataAndBuildTable();
			return;
		}

		const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
		const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

		countdownResultsTarget.html(`Results will refresh in <span>${minutes}:${seconds < 10 ? '0' : ''}${seconds}s</span>`);

		remainingTime -= 1000;
	}, 1000);
}



// Call this function when both fetches are successful
async function fetchDataAndBuildTable() {
	try {
		// Wait for both fetches to complete
		const [resultsHeaderData, resultsStudentData] = await Promise.all([
			fetchResultsHeaderData(),
			fetchResultsStudentData()
		]);

		// Now both data are available, call buildResultsTable
		buildResultsTable(resultsHeaderData, resultsStudentData);
	} catch (error) {
		console.error('Error fetching or building table:', error);
	}
}


function buildResultsTable(resultsHeaderData, resultsStudentData) {
	console.log('buildResultsTable')
	console.log(resultsHeaderData)

	// Clear existing content
	resultsTarget.empty();

	if (resultsHeaderData.length) {
		
		var heading = `
			<div class="results-row results-row-heading" style="grid-template-columns: repeat(` + (resultsHeaderData.length + 2) + `, minmax(0, 1fr));">
				<div class="col">
					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
					<path d="M7,1.167a3.212,3.212,0,0,1,3.208,3.208c0,.851-.282,1.864-1.895,3.261a7.757,7.757,0,0,1,4.365,5.2H1.311A7.531,7.531,0,0,1,5.7,7.648,4.55,4.55,0,0,1,3.792,4.375,3.212,3.212,0,0,1,7,1.167ZM7,0A4.372,4.372,0,0,0,3.842,7.4,8.143,8.143,0,0,0,0,14H14a8.333,8.333,0,0,0-3.844-6.6A4.372,4.372,0,0,0,7,0Z" fill="#00d34d"/>
					</svg>
					<span class="desktop-only">Student</span>
				</div>
		`;
		
		resultsHeaderData.forEach(function(quiz, index) {
			var escapedTitle = quiz.title
				.replace(/'/g, '&#39;')  // Replace single quotes
				.replace(/"/g, '&quot;')  // Replace double quotes
				.replace(/“/g, '&ldquo;')  // Replace left double quotation mark
				.replace(/”/g, '&rdquo;'); // Replace right double quotation mark
			heading = heading + `
				<div class="col tooltip" aria-title="` + escapedTitle + `" data-q="` + quiz.uid + `"><span class="desktop-only">Question </span>#` + (index+1) + `</div>
			`;
		});

		heading = heading + `
			<div class="col">Score</div>
			</div>
		`;

		resultsTarget.append(heading);

	} else {
		
	}

	if (resultsStudentData.length) {
		
		resultsStudentData.forEach(function(student, index) {
			
			if (index % 2 === 1) {
				var rowClass = 'odd';
				// Your logic for odd index
			} else {
				var rowClass = 'even';
			}

			var row = `
				<div class="results-row results-row-` + rowClass + `">
					<div class="student-name">
						` + student.studentName + `
					</div>
				</div>
			`;

			row = row + `
				<div class="results-row results-row-` + rowClass + `" style="grid-template-columns: repeat(` + (resultsHeaderData.length + 2) + `, minmax(0, 1fr));">
					<div class="col">
						<span class="desktop-only">Attempt </span>#1
					</div>
			`;

			var attempt1Score = 0;
			resultsHeaderData.forEach(function(quiz) {
				var answer = student.resultsArray.find(function(res) {
					return res.quizUID === quiz.uid;
				});
				var svg = '';
				var quizUID = '';
				if (answer) {
					quizUID = answer.quizUID;
					if (answer.attempt1 === -1) {
						svg = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g transform="translate(-983.999 -624)"><g transform="translate(965.999 607)"><rect width="19" height="19" rx="9.5" transform="translate(18 17)" fill="#e2e2e2"/></g></g></svg>';
					} else if (answer.attempt1 === 1) {
						svg = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g transform="translate(-18 -17)"><rect width="19" height="19" rx="9.5" transform="translate(18 17)" fill="#00d34d"/><path d="M3.882,6.368l.855-.79A16.441,16.441,0,0,1,7.5,7.231,23.9,23.9,0,0,1,13.6,2l.278.64c-2.141,1.868-3.71,3.949-5.967,8A42.842,42.842,0,0,0,3.882,6.368Z" transform="translate(19 20.333)"/></g></svg>';
						attempt1Score = attempt1Score + 1;
					} else if (answer.attempt1 === 0) {
						svg = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g transform="translate(-983.999 -624)"><g transform="translate(965.999 607)"><rect width="19" height="19" rx="9.5" transform="translate(18 17)" fill="#ed5300"/></g><path d="M9.372,8.295,6.257,5.179,9.372,2.068,8.295,1,5.181,4.113,2.069,1,1,2.069,4.115,5.188,1,8.3,2.069,9.372,5.191,6.255,8.3,9.372Z" transform="translate(988.313 628.314)"/></g></svg>';
					}
				} else {
					svg = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g transform="translate(-983.999 -624)"><g transform="translate(965.999 607)"><rect width="19" height="19" rx="9.5" transform="translate(18 17)" fill="#e2e2e2"/></g></g></svg>';
				}
				
				row = row + `<div class="col" data-uid=` + quizUID + `>` + svg + `</div>`;
			
			});

			row = row + `
				<div class="col">` + attempt1Score + '/' + resultsHeaderData.length + `</div>
				</div>
			`;

			row = row + `
				<div class="results-row results-row-` + rowClass + `" style="grid-template-columns: repeat(` + (resultsHeaderData.length + 2) + `, minmax(0, 1fr));">
					<div class="col">
						<span class="desktop-only">Attempt </span>#2
					</div>
			`;

			var attempt2Score = 0;
			resultsHeaderData.forEach(function(quiz) {
				var answer = student.resultsArray.find(function(res) {
					return res.quizUID === quiz.uid;
				});
				var svg = '';
				if (answer) {
					if (answer.attempt2 === -1) {
						svg = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g transform="translate(-983.999 -624)"><g transform="translate(965.999 607)"><rect width="19" height="19" rx="9.5" transform="translate(18 17)" fill="#e2e2e2"/></g></g></svg>';
					} else if (answer.attempt2 === 1) {
						svg = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g transform="translate(-18 -17)"><rect width="19" height="19" rx="9.5" transform="translate(18 17)" fill="#00d34d"/><path d="M3.882,6.368l.855-.79A16.441,16.441,0,0,1,7.5,7.231,23.9,23.9,0,0,1,13.6,2l.278.64c-2.141,1.868-3.71,3.949-5.967,8A42.842,42.842,0,0,0,3.882,6.368Z" transform="translate(19 20.333)"/></g></svg>';
						attempt2Score = attempt2Score + 1;
					} else if (answer.attempt2 === 0) {
						svg = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g transform="translate(-983.999 -624)"><g transform="translate(965.999 607)"><rect width="19" height="19" rx="9.5" transform="translate(18 17)" fill="#ed5300"/></g><path d="M9.372,8.295,6.257,5.179,9.372,2.068,8.295,1,5.181,4.113,2.069,1,1,2.069,4.115,5.188,1,8.3,2.069,9.372,5.191,6.255,8.3,9.372Z" transform="translate(988.313 628.314)"/></g></svg>';
					}
				} else {
					svg = '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g transform="translate(-983.999 -624)"><g transform="translate(965.999 607)"><rect width="19" height="19" rx="9.5" transform="translate(18 17)" fill="#e2e2e2"/></g></g></svg>';
				}
				
				row = row + `<div class="col">` + svg + `</div>`;
			
			});

			row = row + `
				<div class="col">` + attempt2Score + '/' + resultsHeaderData.length + `</div>
				</div>
			`;


			resultsTarget.append(row);
		});

		

	} else {
		
	}



}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// LESSON POPUP

$(document).on('click','.lesson-card, [data-lesson-popup-trigger]', function(e) {
	console.log('lesson card click')
	var lessonPopupIframe = $('iframe[data-lesson-popup-iframe]');
    e.stopPropagation();
    e.preventDefault();
    var uid = $(this).attr('data-uid');
	var src = siteUrl + '/lesson-popup/' + uid;
	console.log(src);
	lessonPopupIframe.attr('src', src);

	setTimeout(() => {	
		lessonPopupIframe.attr('data-visible', 'true');
		$('body').attr('data-popup-expanded', 'true');
	}, 200);
	return false;

});

$(document).on('click', '[data-lesson-popup-close]', function(e) {
	console.log('data-lesson-popup-close')
	var lessonPopupIframe = window.parent.$('iframe[data-lesson-popup-iframe]');
	lessonPopupIframe.attr('data-visible', 'false');
	window.parent.$('body').attr('data-popup-expanded', 'false');
	var src = siteUrl + '/lesson-popup';
	lessonPopupIframe.attr('src', src);
	return false;
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// LESSON PREVIEW FOR TEACHER

$(document).on('click','[data-lesson-preview-toggle]', function(e) {
	console.log('data-lesson-preview-toggle')
	var revealed = $(this).attr('data-revealed');
	if (revealed == 'true') {
		console.log('data-lesson-preview-close')
		var lessonPreviewIframe = window.parent.$('iframe[data-lesson-preview-iframe]');
		lessonPreviewIframe.attr('data-visible', 'false');
		window.parent.$('body').attr('data-popup-expanded', 'false');
		// var src = siteUrl + '/lesson-popup';
		// lessonPopupIframe.attr('src', src);
		$(this).attr('data-revealed','false')
	} else {
		var lessonPreviewIframe = $('iframe[data-lesson-preview-iframe]');
		e.stopPropagation();
		e.preventDefault();
		var uid = $(this).attr('data-uid');
		var src = siteUrl + '/lesson-preview/' + uid;
		console.log(src);
		// lessonPreviewIframe.attr('src', src);
	
		setTimeout(() => {	
			lessonPreviewIframe.attr('data-visible', 'true');
			$('body').attr('data-popup-expanded', 'true');
			$(this).attr('data-revealed','true')
		}, 200);
	}
	return false;

});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// VIDEO POPUP

$(document).on('click', '[data-video-popup-close]', function(e) {
	console.log('data-video-popup-close')
	$('.video-popup').remove();
	return false;
});

$(async function () {
    if ($('.video-popup').length) {
        var data = {};
        data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
        console.log('VIDEO POPUP DISABLE FOR USER');
        console.log(data);

        try {
            const response = await $.ajax({
                type: 'post',
                url: '/actions/user-module/user/disable-login-popup',
                data: data
            });
            console.log('SUCCESS');
            console.log(response);
        } catch (error) {
            console.log('ERROR');
            console.log(error);
        }
    }
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WISHLIST

var favouriteLessonsTarget = $('[data-favourite-lessons]');

$(function () {
	if (teacherUID) {
		fetchWishlist(teacherUID);
	}
});
var wishlistData = null;

window.fetchWishlist = async function fetchWishlist(teacherUID, refreshSearch = false) {
	console.log('fetchWishlist')
	// console.log(teacherUID)
	if (!teacherUID) {
		return false;
	}
	// console.log('------------------ FETCH WISHLIST')
	var btn = $('[data-wishlist]');
	var requestURL = siteUrl + '/favourite-lessons/' + teacherUID + '.json';
	console.log(requestURL)
	try {
		const response = await $.ajax({
			type: 'get',
			url: requestURL,
		});
		var data = response.data[0];
		if (!data) {
			if ($('[data-favourite]').length) {
				$('[data-favourite]').each(function() {
					var btn = $(this);
					btn.removeAttr('readonly');
				})
			}
			return false;
		}
		wishlistData = data.items;

		var items = wishlistData.length;

		// console.log('wishlistData')
		// console.log(wishlistData)

        btn.attr('data-items', items);

		favouriteLessonsTarget.empty();

		if (favouriteLessonsTarget.length && items) {
			console.log('FAV HERE 1')
			favouriteLessonsTarget.closest('section').attr('data-visible', 'true');
			wishlistHTML = response.data[0].html;
			favouriteLessonsTarget.append(wishlistHTML)
			fetchUsedLessonsData(teacherUID);

			initFavouriteSlider();

			if ($('[data-favourite]').length) {
				$('[data-favourite]').each(function() {
					var btn = $(this);
					var lessonId = btn.attr('data-lesson-id');
					fetchWishlistStatus(btn, lessonId);
				})
			}
		} else if (items) {
			// console.log('FAV HERE 2')
			if ($('[data-favourite]').length) {
				$('[data-favourite]').each(function() {
					var btn = $(this);
					var lessonId = btn.attr('data-lesson-id');
					fetchWishlistStatus(btn, lessonId);
				})
			}

			if ($('.all-lessons-filter-section').length) {
				// console.log('fetchWishlist')
				// var favArray = $('#favArray').attr('data-lesson-ids');
				var elementIds = wishlistData.map(function(entry) {
					return entry.elementId;
				});
				var favItems = elementIds.join(',')
				$('#favArray').attr('data-lesson-ids', favItems)
				if (refreshSearch) {
					// console.log('before ' + favArray)
					$(window).trigger('searchFavRefresh');
				} else {
					
				}
			} else {
				
			}


		} else if (!items) {
			console.log('FAV HERE 3')
			favouriteLessonsTarget.closest('section').attr('data-visible', 'false');

			if ($('[data-favourite]').length) {
				$('[data-favourite]').each(function() {
					var btn = $(this);
					var lessonId = btn.attr('data-lesson-id');
					fetchWishlistStatus(btn, lessonId);
				})
			}
		}

	} catch (error) {
		console.log('Error fetching JSON wishlist data');
		console.log(error);
	}
}

window.fetchWishlistStatus = async function fetchWishlistStatus(btn, lessonId) {
    // console.log('fetchWishlistStatus...');
	// console.log(wishlistData)

	if (wishlistData !== null) {
		
		let exists = false;

		// Iterate over items array and check if lessonId exists
		$.each(wishlistData, function(index, item) {
			// console.log('item.elementId ' + item.elementId);
			if (item.elementId == lessonId) {
				exists = true;
				return false; // Break the loop once found
			}
		});
		// console.log('lessonId ' + lessonId)
		// console.log('exists ' + exists)
		if (exists) {
			// already in wishlist
			btn.attr('data-favourite', 'true');
			btn.removeAttr('readonly');
			btn.find('.label').text('Saved');
		} else {
			// is not in wishlist
			btn.attr('data-favourite', 'false');
			btn.removeAttr('readonly');
			btn.find('.label').text('Save');
		}
	}
}

var data = {};
$(document).on('click', '[data-favourite]', function(e) {
	e.preventDefault();
	e.stopPropagation();
	console.log('click wishlist')
	var btn = $(this);
	btn.attr('readonly', '');
	var lessonId = btn.attr('data-lesson-id');
	var inlist = btn.attr('data-favourite');
	data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
	if (inlist != 'true') {
		data = {
			action: 'wishlist/items/add',
			elementId: lessonId,
		};
		// was not in wishlist
		btn.find('.label').text('Saving');
		$.ajax({
			type: 'get',
			data: data,
			success: function(response) {
				console.log(response);
				if (response.success) {
					btn.attr('data-favourite', 'true');
					btn.removeAttr('readonly');
					btn.find('.label').text('Saved');
				}

				if ($('.all-lessons-filter-section').length) {
					fetchWishlist(teacherUID, true);
				} else {
					fetchWishlist(teacherUID);
				}
			},
			dataType: 'json'
		});
	} else {
		// was already in wishlist
		data = {
			action: 'wishlist/items/remove',
			elementId: lessonId,
		};
		btn.find('.label').text('Remove');
		$.ajax({
			type: 'get',
			data: data,
			success: function(response) {
				// console.log(response);
				if (response.success) {
					btn.attr('data-favourite', 'false');
					btn.removeAttr('readonly');
					btn.find('.label').text('Save');
				}

				if ($('.all-lessons-filter-section').length) {
					fetchWishlist(teacherUID, false);
				} else {
					fetchWishlist(teacherUID);
				}
			},
			dataType: 'json'
		});
	}
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// USED LESSONS

var usedLessonsData = null;

$(function () {
	if ($('.lesson-card').length) {
		fetchUsedLessonsData(teacherUID);
	}
});

window.fetchUsedLessonsData = async function fetchUsedLessonsData(teacherUID) {
	if (!teacherUID) {
		return false;
	}
	var requestURL = siteUrl + '/used-lessons/' + teacherUID + '.json';
	
	// console.log('Fetching fetchUsedLessonsData...');
	// console.log(requestURL)
	try {
		const response = await $.ajax({
			type: 'get',
			url: requestURL,
		});
		
		usedLessonsData = response.data;

		// console.log(usedLessonsData)

		if (usedLessonsData.length) {
			// Iterate through the data and append each result as a separate row
			usedLessonsData.forEach(function(lesson) {
				// console.log(lesson.lessonUID)
				var imgCont = $('.lesson-card[data-uid="' + lesson.lessonUID + '"] .image-container');
				if (imgCont.length && !imgCont.find('.used').length) {
					imgCont.append('<div class="used"><span>Used before</span></div>');
				}
				var imgContPopup = $('.lesson-popup-container[data-lesson-uid="' + lesson.lessonUID + '"] .column-content .keywords');
				if (imgContPopup.length && !imgContPopup.find('.btn-used').length) {
					imgContPopup.prepend('<div class="btn btn-used btn-smaller">Used before</div>');
				}
				var imgContOverview = $('.section-lesson-overview-header[data-lesson-uid="' + lesson.lessonUID + '"] .keywords');
				if (imgContOverview.length && !imgContOverview.find('.btn-used').length) {
					imgContOverview.prepend('<div class="btn btn-used btn-smaller">Used before</div>');
				}
			});

		}


	} catch (error) {
		console.log('Error fetching JSON data');
		console.log(error);
	}

}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SECTOR AND SCHOOL FORMS

$(document).ready(function() {

    // Dropdown for sector
    const $sectorDropdownButton = $('#sector');
    const $sectorDropdownMenu = $('#sector-dropdown-menu');
    const $sectorSelectField = $('select[name="fields[sector][]"]');
    const $sectorSearchInput = $('#sector');
    let isSectorOpen = false;

    // Function to toggle the sector dropdown state
    function toggleSectorDropdown() {
        isSectorOpen = !isSectorOpen;
        $sectorDropdownMenu.toggleClass('hidden', !isSectorOpen);
		$('.portal-form form#registerForm .form-row-sector .errors li').text('');
    }

    $sectorDropdownButton.on('click', function() {
        toggleSectorDropdown();
    });

    // Add event listener to filter sector items based on input
    $sectorSearchInput.on('input', function() {
        const searchTerm = $sectorSearchInput.val().toLowerCase();
        const $sectorItems = $sectorDropdownMenu.find('.option');

		console.log('count ' + $sectorItems.length)

        $sectorItems.each(function() {
            const $item = $(this);
            const text = $item.text().toLowerCase();
            $item.css('display', text.includes(searchTerm) ? 'block' : 'none');
        });
		if (!searchTerm) {
			$sectorSelectField.val('');
		}
    });

    // Handling click event on sector options
    $sectorDropdownMenu.on('click', '.option', function() {
        const selectedValue = $(this).text();
        $('#sector').val(selectedValue);
        $sectorSelectField.val($(this).data('sector-id')); // Update sector select field with selected sector ID
        toggleSectorDropdown(); // Close the sector dropdown after selection
    });

    // Close sector dropdown when clicking anywhere outside of it
    $(document).on('click', function(event) {
        if (!$(event.target).closest('#sector-dropdown-menu').length && !$(event.target).is('#sector')) {
            $sectorDropdownMenu.addClass('hidden');
            isSectorOpen = false;
        }
    });

    // Dropdown for school
    const $schoolDropdownButton = $('#school');
    const $schoolDropdownMenu = $('#school-dropdown-menu');
    const $schoolSelectField = $('select[name="fields[school][]"]');
    const $schoolSearchInput = $('#school');
    let isSchoolOpen = false;

    // Function to toggle the school dropdown state
    function toggleSchoolDropdown() {
        isSchoolOpen = !isSchoolOpen;
        $schoolDropdownMenu.toggleClass('hidden', !isSchoolOpen);
		$('.portal-form form#registerForm .form-row-school .errors li').text('');
    }

    $schoolDropdownButton.on('click', function() {
        toggleSchoolDropdown();
    });

    // Add event listener to filter school items based on input
    $schoolSearchInput.on('input', function() {
        const searchTerm = $schoolSearchInput.val().toLowerCase();
        const $schoolItems = $schoolDropdownMenu.find('.option');

        $schoolItems.each(function() {
            const $item = $(this);
            const text = $item.text().toLowerCase();
            $item.css('display', text.includes(searchTerm) ? 'block' : 'none');
        });
		if (!searchTerm) {
			$schoolSelectField.val('');
		}
    });

    // Handling click event on school options
    $schoolDropdownMenu.on('click', '.option', function() {
        const selectedValue = $(this).text();
        $('#school').val(selectedValue);
        $schoolSelectField.val($(this).data('school-id')); // Update school select field with selected school ID
        toggleSchoolDropdown(); // Close the school dropdown after selection
    });

    // Close school dropdown when clicking anywhere outside of it
    $(document).on('click', function(event) {
        if (!$(event.target).closest('#school-dropdown-menu').length && !$(event.target).is('#school')) {
            $schoolDropdownMenu.addClass('hidden');
            isSchoolOpen = false;
        }
    });

    $('form:not(.ais-SearchBox-form)').on('submit', function(event) {
        $(this).find('button[type="submit"]').text('One moment...');
    });

	$('.portal-form form#registerForm #requestPortalAccess').on('change', function(event) {
		console.log($(this).is(':checked'))
		$('.portal-form form#registerForm .form-row-access .errors li').text('');
		$('.portal-form form#registerForm .form-row-email .errors li').text('');
		if ($(this).is(':checked')) {
			$('.portal-form .form-row-sector').show();
			$('.portal-form .form-row-school').show();
		} else {
			$('.portal-form .form-row-sector').hide();
			$('.portal-form .form-row-school').hide();
			$schoolSelectField.val('');
			$sectorSelectField.val('');
		}
	});

	$('.portal-form form#registerForm #acceptedPrivacyPolicy').on('change', function(event) {
		$('.portal-form form#registerForm .form-row-privacy .errors li').text('');
	});

});
	

$('.portal-form form#registerForm').on('submit', function(event) {
	var form = $(this);
	form.find('button[type="submit"]').text('One moment...');
	event.preventDefault();

	var sectorVal = form.find('[name="fields[sector][]"]').val()
	var sectorInputVal = form.find('[name="fields[sectorInput]"]').val()
	if (sectorVal == '' && sectorInputVal != '') {
		form.find('[name="fields[sector][]"] option').each(function() {
			console.log($(this).text() + ' === ' + sectorInputVal + ' is ' + ($(this).text() === sectorInputVal))
			if ($(this).text() === sectorInputVal) {
				$(this).prop('selected', true);
			}
		});
	}

	var schoolVal = form.find('[name="fields[school][]"]').val()
	var schoolInputVal = form.find('[name="fields[schoolInput]"]').val()
	if (schoolVal == '' && schoolInputVal != '') {
		form.find('[name="fields[school][]"] option').each(function() {
			if ($(this).text() === schoolInputVal) {
				$(this).prop('selected', true);
			}
		});
	}



	var data = form.serialize();
	data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
    console.log('REGISTER')
    console.log(data)

    var acceptedPrivacyPolicy = form.find('#acceptedPrivacyPolicy').is(':checked');
	if (!acceptedPrivacyPolicy) {
		form.find('.form-row-privacy .errors li').text('Please read and accept our Terms and Conditions.')
	}

    $.ajax({
        type: 'post',
        url: '/actions/user-module/user/register',
        data: data,
        success: function (response) {
            console.log('SUCCESS');
            console.log(response);
            var success = response.success;
            if (success) {
                console.log('y')
				if (acceptedPrivacyPolicy) {
					form.off('submit').submit();
				} else {
					form.find('button[type="submit"]').text('Register');
				}
            } else {
                console.log('n')
				if (response.accessError) {
					form.find('.form-row-access .errors li').text(response.accessError);
				}
				if (response.emailError) {
					form.find('.form-row-email .errors.email-error li').text(response.emailError);
				}
				if (response.sectorError) {
					form.find('.form-row-sector .errors li').text(response.sectorError);
				}
				if (response.schoolError) {
					form.find('.form-row-school .errors li').text(response.schoolError);
				}
				form.find('button[type="submit"]').text('Register');
				return false;
            }
        },
        error: function (response) {
			console.log('ERROR');
            console.log(response);
			form.find('button[type="submit"]').text('Register');
			return false;
        }
    });

    return true;

});




$('.profile-update-section form#profileUpdate').on('submit', function(event) {
	var form = $(this);
	form.find('button[type="submit"]').text('One moment...');
	event.preventDefault();

	var sectorVal = form.find('[name="fields[sector][]"]').val()
	var sectorInputVal = form.find('[name="fields[sectorInput]"]').val()
	if (sectorInputVal != '' && sectorVal != sectorInputVal) {
		form.find('[name="fields[sector][]"] option[value=""]').prop('selected', true);
		form.find('[name="fields[sector][]"] option').each(function() {
			if ($(this).text() === sectorInputVal) {
				$(this).prop('selected', true);
			}
		});
	}

	var schoolVal = form.find('[name="fields[school][]"]').val()
	var schoolInputVal = form.find('[name="fields[schoolInput]"]').val()
	if (schoolInputVal != '' && schoolVal != schoolInputVal) {
		form.find('[name="fields[school][]"] option[value=""]').prop('selected', true);
		form.find('[name="fields[school][]"] option').each(function() {
			if ($(this).text() === schoolInputVal) {
				$(this).prop('selected', true);
			}
		});
	}
    // Now submit the form programmatically
    form.off('submit'); // Temporarily disable the submit handler to avoid infinite loop
    form.submit();

});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ANNOUNCEMENT

$(function () {
	announcement();
});

$(window).on('resize', function() {
	announcement();
});

function announcement() {
	console.log('announcement')
    if ($.cookie('announcement-hide')) {
        $('aside.announcement[data-type="announcement"]').slideUp();
    } else {
        $('aside.announcement[data-type="announcement"]').slideDown();
    }
    if ($.cookie('announcement-notification-hide')) {
        $('aside.announcement[data-type="notification"]').slideUp();
    } else {
        $('aside.announcement[data-type="notification"]').slideDown();
    }
}

$(document).on('click', 'aside.announcement[data-type="announcement"] .column-dismiss', function(e) {
	$.cookie('announcement-hide', true);
	$('aside.announcement[data-type="announcement"]').slideUp();
	console.log($.cookie('announcement-hide'));
});

$(document).on('click', 'aside.announcement[data-type="notification"] .column-dismiss', function(e) {
	$.cookie('announcement-notification-hide', true);
	$('aside.announcement[data-type="notification"]').slideUp();
	console.log($.cookie('announcement-notification-hide'));
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TEACHER OVERVIEW - JUMP TO TOP

if (window.location.href.indexOf('lesson-overview/') > -1) {
	$('main').append(`
		<div data-scroll-up class="fixed-scroll-up">
			<svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 65 65">
			<g transform="translate(-1594 -6991)">
			<g transform="translate(1594 6991)" fill="none" stroke="#fff" stroke-width="1.5">
			<circle cx="32.5" cy="32.5" r="32.5" stroke="none"></circle>
			<circle cx="32.5" cy="32.5" r="31.75" fill="none"></circle>
			</g>
			<g transform="translate(1616.131 7011.881)">
			<line x2="24.43" transform="translate(10.989 24.488) rotate(-90)" fill="none" stroke="#fff" stroke-width="2"></line>
			<path d="M15.883.342l.342,15.882L.342,15.882" transform="translate(10.989 22.945) rotate(-135)" fill="none" stroke="#fff" stroke-width="2"></path>
			</g>
			</g>
			</svg>
		</div>
	`);

	//bind events
	if ($('main > [data-scroll-up]').length) {
		var $scrollUpBtn = $('main > [data-scroll-up]');
		var appearHeight = $('body').height() / 2;
		var scrollPos = $(window).scrollTop() + $(window).height();

		if (scrollPos > appearHeight) {
			$scrollUpBtn.addClass('show');
		}

		$(window).scroll(function() {
			scrollPos = $(window).scrollTop() + $(window).height();
			if (scrollPos > appearHeight)
				$scrollUpBtn.addClass('show');
			else
				$scrollUpBtn.removeClass('show');
		})

		$scrollUpBtn.on('click', function() {
			$('html, body').animate({scrollTop: 0}, 'slow');
		})
	}
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ACTIVE MINIS

var activeMinisData = null;
var activeMiniBtnTarget = $('[data-mini-btn]');

$(function () {
	if (teacherUID && activeMiniBtnTarget.length) {
		fetchActiveMinis(teacherUID);
	}
});

window.fetchActiveMinis = async function fetchActiveMinis(teacherUID) {
	console.log('fetchActiveMinis')
	if (!teacherUID) {
		return false;
	}
	
	var requestURL = siteUrl + '/active-minis/' + teacherUID + '.json';
	console.log(requestURL)
	try {
		const response = await $.ajax({
			type: 'get',
			url: requestURL,
		});

		activeMinisData = response.data;

		activeMiniBtnTarget.each(function() {
			var placeholder = $(this);
			var lessonUID = placeholder.attr('data-lesson-uid');

			var match = activeMinisData.find(function (item) {
				return item.originalLessonUID === lessonUID;
			});
		
			if (match) {
				placeholder.html(`<a class="btn btn-black" target="_blank" href="/${match.lessonUID}">Go to live mini</a>`);
			} else {
				placeholder.html(`<button class="btn btn-fill btn-yellow btn-disabled" data-create-live-code data-lesson-uid="${lessonUID}">Run this mini</button>`);
			}

		})

		console.log('activeMinisData')
		console.log(activeMinisData)

	} catch (error) {
		console.log('Error fetching JSON wishlist data');
		console.log(error);
	}
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
